import React from 'react';
import { omit } from 'ramda';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import useApp from 'reducers/hooks/useApp';

import LoanOfficerRegistrationForm from 'sharedComponents/LoanOfficerRegistrationForm';

import { apiErrorsToFormik } from 'utils/errors';
import useStyles from './useStyles';

const LoanOfficerRegistration = props => {
  const classes = useStyles();
  const { signUp } = useApp();
  const { onFinish } = props;

  const handleSubmit = async (values, { setErrors }) => {
    const attrs = omit('passwordConfirmation', values);
    try {
      await signUp({ ...attrs, userType: 'loanOfficer' });
      onFinish();
    } catch (error) {
      const errors = apiErrorsToFormik(error);
      const { fullMessages } = errors;
      setErrors({ serverError: fullMessages });
    }
  };

  return (
    <Box className={classes.container}>
      <LoanOfficerRegistrationForm onSubmit={handleSubmit} />
    </Box>
  );
};

LoanOfficerRegistration.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default LoanOfficerRegistration;



// WEBPACK FOOTER //
// ./src/components/SignUp/components/LoanOfficerRegistration/LoanOfficerRegistration.js